<template>
    <div class="m-3">
        <h3>Edit Product</h3>
        <div v-if="pageLoading" class="mt-3">
            Loading...
        </div>
        <EditElement :elementIdProp="pageId" category_id="7"></EditElement>
    </div>
</template>

<script>
import EditElement from "@/components/ElementComponents/EditElement";

export default {
    name: 'editProduct',
    components: {
        EditElement,
    },
    data() {
        return {
            pageId: null,
        };
    },
    created() {
        this.pageId = this.$route.params.id;
    },
}
</script>